import Api from '@/api/api.js'

export default {

    /**
     * Liste des fournisseurs
     */
    fournisseurs () {
        const promise = Api().get('/fournisseurs')
        return promise.then((response) => response.data)
    },

    saveFournisseur (data) {
        const promise = Api().post('/fournisseurs', data)
        return promise.then((response) => response)
    },

    getFournisseur (id) {
        const promise = Api().get('/fournisseur/'+id)
        return promise.then((response) => response.data)
    },

    editFournisseur (id, data) {
        const promise = Api().put('/fournisseur/'+id, data)
        return promise.then((response) => response.data)
    },

    deleteFournisseur (id) {
        const promise = Api().delete('/fournisseur/'+id)
        return promise.then((response) => response.data)
    },

    deletedFournisseurs () {
        const promise = Api().get('/fournisseurs/deleted')
        return promise.then((response) => response.data)
    }

}